import React from 'react';
import RadioButton from 'components/vistaprintUILibrary/RadioButton';


export default function OptionSet(props) {
    const {
        name,
        options,
        onChange,
    } = props;

    return(
        <div className="radio-buttons">
            {options.map(option => (
                <RadioButton
                    key={`${name}-option-${option.value}`}
                    label={option.text}
                    value={option.value}
                    selected={option.selected}
                    onClick={onChange}
                    style={{
                        marginBottom: 7,
                    }}
                />
            ))}
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/vistaprintUILibrary/OptionSet.js